import Vue from 'vue'
import App from './App.vue'
// import 'minireset.css'
import './assets/css/icon.css'

import  plugin from './plugin'
// import 'babel-polyfill'
import 'element-ui/lib/theme-chalk/index.css';
//注册插件
Object.keys(plugin).forEach((key) => {
    plugin [key].install(Vue);
})

String.prototype.trimlr = function() {

    return this.replace(/^\s+/, '').replace(/\s+$/, '');

}

import '@babel/polyfill'
import toastRegistry from '../src/components/toast/message';
Vue.use(toastRegistry);

import {
    // Button,
    Radio,
    Checkbox,
    Select,
    Option,
    Input,
    DatePicker,
    TimePicker,
    TimeSelect,
    RadioGroup,
    CheckboxGroup,
    OptionGroup,
    // Form,
    // FormItem,
    Progress,
    Loading
} from 'element-ui'

Vue.use(TimeSelect)
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup)
Vue.use(DatePicker);
// Vue.use(Button);
Vue.use(Radio);
Vue.use(RadioGroup);
// Vue.use(Form);
// Vue.use(FormItem);
Vue.use(CheckboxGroup);
Vue.use(Progress);
Vue.use(TimePicker)



Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#'+window.bindEleId);
